<script>
export default {
  name: 'Jivosite',
  computed: {
    currUser() { return this.$store.state.auth?.user; },
  },
  watch: {
    currUser(val) {
      if (!val) return;

      const supportChatDisabled = val?.customSettings?.settings?.supportChatDisabled;
      if (supportChatDisabled) return;

      const script = document.createElement('script');
      script.setAttribute('src', '//code.jivo.ru/widget/lX5SSywEeN');
      document.head.appendChild(script);
    },
  },
};
</script>

<template>

</template>
